/* EasySell COD form - keep card buttons alive after AJAX re-renders.
   The app injects its "Order now" button once, on load. Collection
   filtering (2.0-filters.js) replaces the whole product grid, so the
   injected buttons vanish. This re-inserts them using the app's own
   template and opens the app's popup on click. */
(function () {
  'use strict';

  var FORM_SELECTOR = '.orlisse-product-card__form form[action*="/cart/add"]';
  var BUTTON_CLASS = 'es-popup-button';
  var appReady = false;
  var timer = null;

  function appInstance() {
    var app = window.easysellApp;
    var vm = app && app.$children && app.$children[0];
    if (!vm || typeof vm.generatePopupButton !== 'function' || typeof vm.popupListner !== 'function') return null;
    return vm;
  }

  function onClick(form, vm) {
    return function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.ES_CLOSEST_FORM = form;
      vm.popupListner();
    };
  }

  function inject() {
    if (!appReady) return;
    var vm = appInstance();
    if (!vm) return;
    var forms = document.querySelectorAll(FORM_SELECTOR);
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.querySelector('.' + BUTTON_CLASS)) continue;
      var submit = form.querySelector('[type="submit"]');
      if (!submit) continue;
      submit.insertAdjacentHTML('afterend', vm.generatePopupButton(window.ESPBPS || ''));
      var button = form.querySelector('.' + BUTTON_CLASS);
      if (!button) continue;
      button.addEventListener('click', onClick(form, vm));
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(inject, 150);
  }

  // The app calls this hook after its own insertion pass; only then is it
  // safe to add buttons ourselves without duplicating the app's.
  var previous = window.es_after_insertion_completed;
  window.es_after_insertion_completed = function () {
    if (typeof previous === 'function') previous.call(window);
    appReady = true;
    schedule();
  };

  function start() {
    if (!document.querySelector('.orlisse-product-card__form')) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
